export const maskPrice = value => {
  if (typeof value !== 'string') return value;
  return value.replace(/[0-9]/g, '*');
};

export const getPriceDisplayValue = (value, isAuthenticated) =>
  isAuthenticated ? value : maskPrice(value);

export const shouldBlurPrice = isAuthenticated => !isAuthenticated;
